import { useCallback, useState } from 'react'

type TuseNavigation = (props: { initialPosition?: number; max: number; infinite?: boolean; step?: number }) => {
  currentPosition: number
  next: () => void
  previous: () => void
  goTo: (nextPosition: number) => void
  isFirst: boolean
  isLast: boolean
}

const useNavigation: TuseNavigation = ({ initialPosition = 0, max, infinite = false, step = 1 }) => {
  const [currentPosition, setCurrentPosition] = useState(initialPosition)
  const isLast = infinite ? false : currentPosition === max
  const isFirst = infinite ? false : currentPosition === 0

  const next = useCallback(() => {
    if (isLast) return
    setCurrentPosition(position => {
      const nextPosition = position + step
      if (nextPosition > max) {
        if (infinite) return nextPosition - max - 1
        return max
      }
      return nextPosition
    })
  }, [isLast, step, infinite, max])

  const previous = useCallback(() => {
    if (isFirst) return
    setCurrentPosition(position => {
      const nextPosition = position - step
      if (nextPosition < 0) {
        if (infinite) return max - nextPosition
        return 0
      }
      return nextPosition
    })
  }, [isFirst, step, max, infinite])

  const goTo = useCallback(nextPosition => {
    setCurrentPosition(nextPosition)
  }, [])

  return {
    currentPosition,
    next,
    previous,
    isFirst,
    isLast,
    goTo,
  }
}

export default useNavigation
